import { render, staticRenderFns } from "./RevenueCardShimmer.vue?vue&type=template&id=f0ada12c&"
import script from "./RevenueCardShimmer.vue?vue&type=script&lang=js&"
export * from "./RevenueCardShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
